import { Entity, formatTicker, PriceHistory } from '@api';
import { percentChangeFromReference } from '@helpers';
import { LineData } from '@terminal/modules/market-reaction-charts/types';

type PricePoint = { time: string; value?: number };

export type BuildSingleEtfLineArgs = {
  entity: Entity;
  priceData: PricePoint[];
  prevCloseData?: PriceHistory[number];
  lastProportionChange?: number;
  lastKnownPrice?: number;
  lastKnownDate?: string;
  asPercentChange?: boolean;
};

export const buildSingleEtfLine = ({
  entity,
  priceData,
  prevCloseData,
  lastProportionChange,
  lastKnownPrice,
  lastKnownDate,
  asPercentChange,
}: BuildSingleEtfLineArgs): LineData => {
  const data = asPercentChange
    ? priceData.map(point => ({
        time: point.time,
        value: percentChangeFromReference(point.value, prevCloseData?.close),
      }))
    : priceData;

  return {
    data,
    label: formatTicker(entity),
    prevCloseData,
    lastProportionChange,
    lastKnownPrice,
    lastKnownDate,
    subject: { type: 'entity', data: entity },
  };
};
